import icon from "../../assets/plug-us.svg";
import type { Property } from "../../types";

export const powerMethod: Property = {
  id: "powerMethod",
  title: "powerMethod.title",
  icon,
};
